
import { AnalyticsProvider } from './base';
import { FirebaseAnalyticsProvider } from './firebase';

// Export all providers
export { FirebaseAnalyticsProvider };

// Export the interface
export type { AnalyticsProvider };

/**
 * Get the configured analytics provider
 */
export const getProvider = (): AnalyticsProvider => {
  // We're starting with Firebase, but this could read from config
  // to determine which provider to use in the future
  return new FirebaseAnalyticsProvider();
};
